module.exports.brute = {
  vi: {
    title: 'Kẻ bạo lực (Brute) trong Avalon: luật Nhiệm vụ và chiến thuật',
    description:
      'Kẻ bạo lực có thể phá hỏng mọi Nhiệm vụ trong Avalon không? Tìm hiểu giới hạn ở ba Nhiệm vụ đầu, thẻ Thành công về sau và sự khác biệt với Kẻ điên.',
    keywords: ['Kẻ bạo lực', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Bruto em Avalon: missões, regras e estratégia',
    description:
      'Quando o Bruto pode falhar em Avalon? Entenda o limite das três primeiras missões, o Sucesso obrigatório no final e a diferença para o Lunático.',
    keywords: ['Bruto', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Brute in Avalon: Rules, Missions & Strategy',
    description:
      'Can the Brute fail every quest in Avalon? Learn the first-three-missions restriction, later Success cards and how the role differs from the Lunatic.',
    keywords: ['Brute', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Брут в Авалоне: правила миссий и стратегия',
    description:
      'Когда Брут может провалить миссию в Авалоне? Первые три похода, обязательный успех в конце игры и отличия от Лунатика — с примерами.',
    keywords: ['Брут', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆野蠻人：任務限制與玩法策略',
    description:
      '阿瓦隆野蠻人什麼時候能出失敗？了解前三次任務的選擇、第四和第五次任務必須成功的限制，以及與瘋子的區別。',
    keywords: ['野蠻人', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆野蛮人：任务限制与玩法策略',
    description:
      '阿瓦隆野蛮人什么时候能出失败？了解前三次任务的选择、第四和第五次任务必须成功的限制，以及与疯子的区别。',
    keywords: ['野蛮人', '角色', '规则', '建议'],
  },
  es: {
    title: 'Bruto en Avalon: misiones, reglas y estrategia',
    description:
      '¿Cuándo puede fallar el Bruto en Avalon? Conoce el límite de las tres primeras misiones, el Éxito obligatorio al final y la diferencia con el Lunático.',
    keywords: ['Bruto', 'Rol', 'Reglas', 'Consejos'],
  },
};
